import React, { useState, useEffect } from "react";
import { Redirect, Link } from 'react-router-dom'
import axios from 'axios'

import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row
} from "reactstrap";
import useForm from '../../lib/useForm'
import logo from "assets/img/logo-login.png";
import settings from '../../settings'
import rotas from '../../services/rotas'
import SweetAlert from 'sweetalert-react'
import 'sweetalert/dist/sweetalert.css'
import './style.css'

import NumberFormat from 'react-number-format';

const INITIAL_FORM = {
  cpf: '',
  senha: ''
}

const Login  = () => {
  const [autenticado, setAutenticado] = useState(false)
  const [form, onChange]              = useForm(INITIAL_FORM)
  const [erro, setErro]               = useState('')
  const [mostrarSenha, setMostrarSenha] = useState(false)

  useEffect(() => {
    document.body.classList.toggle("login-page");
    return () => {
      document.body.classList.toggle("login-page");
    }
  }, [])
  useEffect(() => {
    const token = sessionStorage.getItem('token')
    if(token){
      setAutenticado(true)
      emptyCache();
    }
  }, [])

 

  const logar = async(credenciais) => {
    const url = settings.url+rotas.login
    try{
      const token = await axios.post(url, credenciais)
      // console.log(token.data);
      if(token.data.erro === "nao"){
        sessionStorage.setItem('token', token.data.token)
        sessionStorage.setItem('rede', token.data.rede)
        sessionStorage.setItem('usuario_id', token.data.usuario_id)
        sessionStorage.setItem('usuario', token.data.usuario)
        sessionStorage.setItem('cpf', token.data.cpf)
        setAutenticado(true)
        // console.log(token.data.cpf)
      }else{
        form.senha = ''
        setErro('Erro ao identificar usuário')
      }
    }catch(err){
      form.senha = ''
      setErro('Erro ao identificar usuário')
    }
  }
  if(autenticado){
    return <Redirect to='/painelwebgestor/admin/Principal' />
  }


  
  const emptyCache = ()=>{
    if('caches' in window){
    caches.keys().then((names) => {
            // Delete all the cache files
            names.forEach(name => {
                caches.delete(name);
            })
        });
  
        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
    }
  }

  return (
    <div className="login-page">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="4" md="6" sm="10" xs="11">
            <Form action="" className="form" method="">
              <Card className="card-login  text-center">
                <CardHeader className="text-center p-0">
                  <div className="logo">
                    <div className="logo-img">
                      <img src={logo} alt="WebGestor" style={{ width: '50%' }}/>
                    </div>
                  </div>
                  <CardTitle tag="h4">Web Gestor</CardTitle>
                </CardHeader>

                <CardBody>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-single-02" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <NumberFormat
                      id          = "cpf"
                      name        = "cpf"
                      placeholder = "CPF"
                      type        = "text"
                      mask        = "_"
                      format      = "###.###.###-##"
                      value       = {form.cpf}
                      onChange    = {onChange('cpf')}
                      className   = "form-control"
                    />
                  </InputGroup>

                  <InputGroup className="mb-0">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-key-25" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      id            = "Senha"
                      name          = "Senha"
                      placeholder   = "Senha"
                      type          = {mostrarSenha ? "text" : "password"}
                      maxLength     = "10"
                      autoComplete  = "off"
                      value         = {form.senha}
                      onChange      = {onChange('senha')}
                      onKeyDown     = {e => {
                                        if (e.key === 'Enter') {
                                        e.preventDefault()
                                        logar(form)
                                      }}}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText
                        style={{ cursor: 'pointer' }}
                        onClick={() => setMostrarSenha(v => !v)}
                        title={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                      >
                        <i className={mostrarSenha ? "nc-icon nc-visible-40" : "nc-icon nc-lock-circle-open"} />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </CardBody>

                <CardFooter>
                  <Button
                    className = "btn-round"
                    color     = "primary"
                    href      = "#"
                    onClick   = {e => {
                                e.preventDefault()
                                logar(form)
                              }}
                  >
                    Entrar
                  </Button>
                  <br />
                  <Link
                    to="/painelwebgestor/auth/senha"
                    style={{ fontSize: "12px", color: "#888", marginTop: "6px", display: "inline-block" }}
                  >
                    Esqueci a senha
                  </Link>

                  <SweetAlert
                      danger
                      show              = {erro!==''}
                      style             = {{display: "block",marginTop: "-100px"}}
                      title             = "Atenção!"
                      text              = {erro}
                      confirmBtnBsStyle = "info"
                      onConfirm         = {() => setErro('')}
                  />

                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      <div
        className = "full-page-background"
        style     = {{
                      backgroundImage: `url(${require("assets/img/bg/webgestor_login_bg.jpg")})`
                    }}
      />
    </div>
  );
}

export default Login;
